<template>
  <div
    class="invoice-order-card"
    :class="[
      `invoice-order-card-${mode}`,
      { active: selected }
    ]"
    @click="handleSelect"
  >
    <BaseRadio
      class="order-radio"
      :value="selected ? order.orderNo : ''"
      :option-value="order.orderNo"
      name="invoice-order"
      variant="compact"
    ></BaseRadio>
    <span class="order-fields">
      <span class="order-number-field">
        <em>订单编号</em>
        <strong class="order-number" :title="order.orderNo">{{ order.orderNo }}</strong>
        <button class="copy-mini" type="button" aria-label="复制订单编号" @click.stop="handleCopy">
          <img :src="copyIcon" alt="">
        </button>
      </span>
      <span>
        <em>套餐</em>
        <strong>{{ order.packageName }}</strong>
      </span>
      <span>
        <em>支付时间</em>
        <strong>{{ order.paidAt }}</strong>
      </span>
      <span>
        <em>金额</em>
        <strong>{{ order.amountText }}</strong>
        <i>{{ order.status }}</i>
      </span>
    </span>
  </div>
</template>

<script>
import BaseRadio from '@/components/BaseRadio.vue'
import copyIcon from '@/assets/images/user/copy.svg'

// 常量：订单卡片展示模式，主卡片与下拉选项使用不同尺寸布局
const CARD_MODES = ['selected', 'option']

export default {
  name: 'InvoiceOrderCard',
  components: { BaseRadio },
  props: {
    // 参数：当前订单数据，字段由发票订单服务统一适配
    order: {
      type: Object,
      required: true
    },
    // 关键状态：控制卡片选中样式和单选按钮状态
    selected: {
      type: Boolean,
      default: false
    },
    // 参数：控制卡片在主区域或订单列表中的展示样式
    mode: {
      type: String,
      default: 'selected',
      validator(value) {
        return CARD_MODES.indexOf(value) > -1
      }
    }
  },
  data() {
    return {
      copyIcon
    }
  },
  methods: {
    // 方法：通知父组件选中当前订单
    handleSelect() {
      this.$emit('select', this.order)
    },
    // 方法：通知父组件复制当前订单号
    handleCopy() {
      this.$emit('copy', this.order)
    }
  }
}
</script>

<style scoped lang="less">
.invoice-order-card{
  min-height: 100px;
  padding: 24px 20px;
  border: 1px solid #8EBBFF;
  border-radius: 6px;
  background: #EAF3FF;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
}

.invoice-order-card-selected{
  width: 486px;
  margin-top: 15px;
}

.invoice-order-card-option{
  width: 100%;
  margin: 0 0 8px;
  padding: 18px 20px;

  &:last-child{
    margin-bottom: 0;
  }

  &:hover,
  &.active{
    background: #EDF4FF;
  }
}

.order-radio{
  margin-right: 25px;
  flex-shrink: 0;
}

.order-fields{
  flex: 1;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(0, 1fr);
  row-gap: 12px;
  column-gap: 12px;

  span{
    min-width: 0;
    color: #666;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
  }

  em{
    margin-right: 18px;
    color: #666;
    font-style: normal;
    white-space: nowrap;
  }

  strong{
    color: #666;
    font-weight: 400;
    white-space: nowrap;
  }

  i{
    height: 18px;
    margin-left: 10px;
    padding: 0 6px;
    border-radius: 6px;
    background: #fff;
    color: #2F7BFF;
    font-size: 10px;
    line-height: 18px;
    font-style: normal;
  }
}

.order-number-field{
  min-width: 0;
}

.order-number{
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.copy-mini{
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  margin-left: 8px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;

  img{
    width: 12px;
    height: 12px;
  }
}
</style>
